module.exports = __webpack_public_path__ + "static/media/screenshot35.55f77282.png";